var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeactivatedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 110,
    viewBox: "0 0 125 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.001 110H13.2931L0.197266 99.288L94.1164 21.9695L102.301 25.9401L125.001 110Z",
    fill: "#8650F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.823 80.5474H0V99.3098H107.823V80.5474Z",
    fill: "#CC99FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 80.5473H107.844L91.7802 12.0427H0V80.5473Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6445 69.5298C75.8259 69.5298 90.6679 60.2358 90.6679 48.8257C90.6679 37.4373 75.8259 28.1216 57.6445 28.1216C39.4631 28.1216 24.6211 37.4155 24.6211 48.8257C24.6429 60.2358 39.4631 69.5298 57.6445 69.5298Z",
    fill: "#E6CCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.244 63.2466C63.1434 63.2466 73.6638 55.8289 73.6638 46.7313C73.6638 37.6338 63.1434 30.2161 50.244 30.2161C37.3446 30.2161 26.8242 37.6338 26.8242 46.7313C26.8242 55.8289 37.3446 63.2466 50.244 63.2466Z",
    fill: "#5C18B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2437 57.618C68.3378 57.618 83.1143 44.6807 83.1143 28.7981C83.1143 12.9373 68.3596 0 50.2437 0C32.1495 0 17.373 12.9373 17.373 28.7981C17.373 44.6807 32.1495 57.618 50.2437 57.618Z",
    fill: "#410E81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2437 0C58.3849 0 65.8277 2.59619 71.5681 6.89409C72.0701 8.90123 72.3538 10.9956 72.3538 13.1555C72.3538 29.0599 57.6428 41.9754 39.4832 41.9754C31.342 41.9754 23.8991 39.3792 18.1588 35.0813C17.6568 33.0742 17.373 30.9798 17.373 28.8199C17.373 12.8937 32.0841 0 50.2437 0Z",
    fill: "#673E9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7506 31.8961C39.6575 27.5982 44.6995 22.5585 50.2434 17.977C55.7655 22.5585 60.8292 27.62 64.7143 31.8961C66.2858 30.8053 70.2364 26.2456 71.1094 23.4312C68.1847 20.1805 63.2083 16.0135 57.8171 12.2392C61.4185 9.81755 65.0853 7.76678 68.6867 6.37051C66.4822 4.86515 63.994 3.55615 61.0256 2.53076C58.0572 3.27253 54.2376 5.0615 50.2434 7.3959C46.2491 5.08332 42.4295 3.29435 39.4393 2.55258C36.4927 3.57797 34.0045 4.88697 31.8 6.39232C35.3796 7.7886 39.0464 9.81755 42.6478 12.261C37.2566 16.0353 32.302 20.2023 29.3555 23.453C30.2504 26.2674 34.1791 30.8053 35.7506 31.8961Z",
    fill: "#410E81"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7517 31.896C39.6586 27.5981 44.7005 22.5584 50.2444 17.9769C55.7665 22.5584 60.8303 27.6199 64.7154 31.896C66.1559 30.8924 69.4299 27.0745 70.6958 24.2601C67.7274 21.053 63.0784 17.0606 57.6218 13.4172V12.2391C60.8957 10.0574 64.2352 8.18117 67.4655 6.82853C65.5448 5.62861 63.4494 4.55959 60.983 3.70874C58.0147 4.42869 54.2169 6.21766 50.2226 8.53024C46.2284 6.21766 42.4087 4.42869 39.4404 3.70874C36.974 4.55959 34.7913 5.62861 32.8706 6.82853C36.1009 8.18117 39.5277 10.0574 42.5834 12.2391V13.4172C37.5633 17.0606 32.6305 21.053 29.6621 24.2601C30.9062 27.0745 34.333 30.9142 35.7517 31.896Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivatedActive);
export default __webpack_public_path__ + "static/media/deactivated_active.384e4da5e7cf2a418978a2fc33628d4a.svg";
export { ForwardRef as ReactComponent };